import { Blob, DirectUpload } from '@rails/activestorage';

const END_POINT = '/rails/active_storage/direct_uploads';

export interface Uploadable {
  progress?: number;
  timeLeftInMinutes?: string;
  isUploaded?: boolean;
  [key: string]: unknown;
}

export class Uploader {
  uploadable: Uploadable;
  file: File;
  notify: (uploadable: Uploadable) => void;

  constructor(
    uploadable: Uploadable,
    file: File,
    notify: (uploadable: Uploadable) => void
  ) {
    this.uploadable = uploadable;
    this.file = file;
    this.notify = notify;

    this.begin = this.begin.bind(this);
    this.directUploadDidProgress = this.directUploadDidProgress.bind(this);
  }

  begin(): Promise<Blob | undefined> {
    const directUploader = new DirectUpload(this.file, END_POINT, this);
    return new Promise((resolve, reject) => {
      directUploader.create((error, blob) => {
        if (error) {
          reject(error);
        } else {
          resolve(blob);
        }
      });
    });
  }

  directUploadWillCreateBlobWithXHR(request: XMLHttpRequest) {
    request.withCredentials = true;
  }

  directUploadWillStoreFileWithXHR(request: XMLHttpRequest) {
    request.upload.addEventListener('progress', (event) =>
      this.directUploadDidProgress(event)
    );
  }

  directUploadDidProgress(event: ProgressEvent) {
    let uploadable = { ...this.uploadable };
    uploadable = this.updateUploadable(event, uploadable);
    this.notify(uploadable);
  }

  updateUploadable(event: ProgressEvent, uploadable: Uploadable): Uploadable {
    uploadable.progress = this.progress(event);
    uploadable.timeLeftInMinutes = this.timeLeftInMinutes(event);

    if (event.loaded >= event.total) {
      uploadable.isUploaded = true;
      uploadable.progress = 100;
      uploadable.timeLeftInMinutes = undefined;
    }

    return uploadable;
  }

  progress(event: ProgressEvent) {
    return (event.loaded / event.total) * 100;
  }

  timeLeftInMinutes(event: ProgressEvent) {
    const timeRunningInSeconds = event.timeStamp / 1000;
    const kbps = event.loaded / timeRunningInSeconds / 1024;
    const kbpsLeft = (event.total - event.loaded) / 1024;

    return (kbpsLeft / kbps / 60).toFixed(0);
  }
}
